const toggleDropdown = (el) => {
    $(el).toggleClass('active').next().slideToggle();
    // $(el).find('.far').toggleClass('fa-plus fa-minus');
    $(el).find('.fas').toggleClass('fa-angle-down fa-angle-up');
    $(el).parent().toggleClass('active');
}

$(document).on('click', '.dropdown-menu-toggler', function() {
    $('.dropdown-menu-toggler.active').not($(this)).each(function() {
        toggleDropdown($(this));
    });
    toggleDropdown($(this));
});
